import { render, staticRenderFns } from "./recursiveEsrs.vue?vue&type=template&id=241a8d10&scoped=true"
import script from "./recursiveEsrs.vue?vue&type=script&setup=true&lang=ts"
export * from "./recursiveEsrs.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./recursiveEsrs.vue?vue&type=style&index=0&id=241a8d10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@7.0.0-bridge.0_@babel+core@7.26.0__cache-loader@4.1.0_webpack@4_duly6tfyc62fvcli236pnhbyri/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "241a8d10",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IxTdRecursiveEsrs: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/td/recursiveEsrs.vue').default,IxSearchText: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/SearchText.vue').default,IxBtnAddIro: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/btn/AddIro.vue').default,CsrdEsrsStatus: require('/home/runner/work/assessment-service/assessment-service/frontend/components/csrd/EsrsStatus.vue').default,CsrdIroCell: require('/home/runner/work/assessment-service/assessment-service/frontend/components/csrd/IroCell.vue').default,IxTextField: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/TextField.vue').default,IxDataTable: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/DataTable.vue').default})
